export const GET_VITAL_LIST_DATA = 'GET_VITAL_LIST_DATA'
export const GET_VITAL_DATA = 'GET_VITAL_DATA'
export const SET_VITAL_LOADING = 'SET_VITAL_LOADING'
export const CLEAR_VITALS = 'CLEAR_VITALS'
